export default __webpack_public_path__ + "static/media/holiday-pattern.d2c5ebac.svg";